export default __webpack_public_path__ + "static/media/marazzi_crogiolo_luz_001.c4034d55.jpg";